<template>
  <el-dialog title="编辑贴标费" top="8vh" :visible.sync="dialogVisible" width="500px" @close="handleDialogClose">
    <el-form :model="itemForm" :rules="itemRules" ref="itemForm" label-width="120px">
      <el-form-item label="订单号" prop="orderSn">
        <el-input v-model="itemForm.orderSn" placeholder="订单号" readonly></el-input>
      </el-form-item>

      <el-form-item label="贴标费" prop="stickFee">
        <el-input-number
          v-model="itemForm.stickFee"
          :precision="2"
          :step="0.01"
          :min="0"
          controls-position="right"
          style="width: 200px;">
        </el-input-number>
        <span style="margin-left: 10px; color: #909399;">元</span>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
      <el-button @click="handleCancel">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateErpOrderStickFee } from '../../api/OrdPurchase'

export default {
  name: 'OrdPurchaseStickFeeEdit',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      itemForm: {
        orderSn: '',
        stickFee: 0
      },
      itemRules: {
        stickFee: [
          { required: true, message: '请输入贴标费', trigger: 'blur' },
          { validator: (_, value, callback) => {
            if (value < 0) {
              callback(new Error('贴标费不能小于0'))
            } else {
              callback()
            }
          }, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.initForm()
      }
    },
    editData: {
      handler(newData) {
        if (this.visible && newData) {
          this.initForm()
        }
      },
      deep: true
    }
  },
  methods: {
    initForm() {
      if (this.editData) {
        this.itemForm = {
          orderSn: this.editData.orderSn || '',
          stickFee: this.editData.stickFee != null ? this.editData.stickFee : 0
        }
      } else {
        this.itemForm = {
          orderSn: '',
          stickFee: 0
        }
      }
    },

    handleSubmit() {
      this.$refs.itemForm.validate((valid) => {
        if (valid) {
          const submitData = {
            orderSn: this.itemForm.orderSn,
            stickFee: this.itemForm.stickFee
          }

          updateErpOrderStickFee(submitData)
            .then(response => {
              if (response.success) {
                this.$message.success('保存成功')
                this.$emit('submit', submitData)
                this.dialogVisible = false
              } else {
                this.$message.error('保存失败：' + response.message)
              }
            })
            .catch(error => {
              console.error('保存失败:', error)
              this.$message.error('保存失败，请稍后重试')
            })
        } else {
          this.$message.warning('请完善表单信息')
          return false
        }
      })
    },

    handleCancel() {
      this.dialogVisible = false
    },

    handleDialogClose() {
      this.$refs.itemForm.resetFields()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/order/OrdPurchaseStickFeeEdit.vue